import React, { Component } from 'react';

import { Offcanvas, Container , Row, Col, Tab, Tabs, Card, Form, Button } from 'react-bootstrap';

import CommonButton from '../components/CommonButton';
import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';
import CommonFile from '../components/CommonFile';
import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import ReCAPTCHA from 'react-google-recaptcha';

import logoWhite from '../../assets/img/EEC-Logo-White.svg';
import logoOrange from '../../assets/img/Logo-th.png';
import leftSideBg from '../../assets/img/registerBackgroud.png';
/**
import CustomDatePicker from "../components/CommonDatePicker";
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

import * as Actions from '../actions/ActionCenter';
import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

class InputRegister extends Component {

    constructor(props) {
        super(props);
        this.state = {
            recaptchaToken: null,
            recaptchaExpired: false,
        };
    }
    
    handleRecaptchaChange = (token) => {
        this.setState({ recaptchaToken: token, recaptchaExpired: false });
    };

    handleRecaptchaExpired = () => {
        this.setState({ recaptchaToken: null, recaptchaExpired: true });
    };

    prepareInputs = async () => {
        const {Action, Inputs, onUpdateState } = this.props;  // URL
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }
    
    render = () => {

        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onPreviewFile, onDeleteFile } = props;

        let { App, Action, Inputs, InputGroup, Masterbase, Operation } = props;
        
        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;
        
        let isLoading = Action.Loading.submit;

        return (
            <Container fluid className="vh-100 d-flex">
                <Row className="flex-fill">
                    {/* Left Side */}
                    <Col md={4}
                        className="d-flex flex-column justify-content-between align-items-center text-white"
                        // style={{
                        //     backgroundColor: '#f99e39',
                        //     backgroundImage: `url(${leftSideBg})`,
                        //     padding: '5%',
                        //     backgroundSize: 'cover',
                        //     color: 'white',
                        //     textAlign: 'center',
                        style={{
                            backgroundColor: '#eae9e5',
                            backgroundImage: `url(${leftSideBg})`,
                            padding: '5%',
                            backgroundSize:  window.innerWidth < 768 ? '100%' : '100% auto',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            color: 'white',
                            textAlign: 'center',
                            height: window.innerWidth < 768 ? '35%' : ''
                        }}>
                        <div className="text-center" style={{ marginTop: '-30px' }}>
                            {!(window.innerWidth < 768) && <img
                                src={logoOrange}
                                alt="EEC Logo"
                                style={{ 
                                    width: '65%',
                                    filter: 'drop-shadow(-10 6px 12px rgba(0,0,0,0.35))',
                                }}
                            />}
                        </div>
                        <Row className="d-flex justify-content-center align-items-start" style={{ width: '100%' }}>
                            <div className="text-center">
                                {/* <p className="mt-5" style={{ color: '#FFFFFF99', fontSize: 14 }}>
                                    &copy; 2019 Eastern Economic Corridor (EEC) Office
                                </p> */}
                            </div>
                        </Row>
                    </Col>

                    {/* Right Side */}
                    <Col md={8}
                        className="d-flex flex-column"
                        style={{
                            height: '100vh',
                            overflowY: 'auto',
                            paddingTop: '5%',
                            paddingBottom: '5%',
                            paddingLeft: '12%',
                            paddingRight: '12%',
                        }}>
                        <div className="mb-4">
                            <h2 className="text-orange fw-bold mb-5">ลงทะเบียนผู้ใช้</h2>
                        </div>
                        <Form onSubmit={this.handleSubmit}>
                            
                            <Row>
                                <Col xs={12} sm={12} md={6} className="">{util.formatLabel('', Inputs.register_type)}</Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={12} md={6} className="mb-1">
                                    <CommonSelect
                                        element="Inputs"
                                        input={Inputs.register_type}
                                        option={{source: 'options', section: 'register_type', item: 'default'}}
                                        hr={false}
                                        floatingLabel={false}
                                        callback={async (e, element) => { 
                                            await onInputChange(e, element);
                                        }}
                                    /> 
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col md={12}><hr className="hr-custom" /></Col>
                            </Row>
                           
                            {['1'].includes(Inputs.register_type.value) && (
                                <>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.operator_name}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.benefits_id}
                                                option={{source: 'db', data: Masterbase?.benefits}}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                                disabled={false}
                                            />
                                        </Col>
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.target_industries_id}
                                                option={{source: 'db', data: Masterbase?.target_industries}}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                                disabled={false}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.executive}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.position}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.coordinator_name}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                            />
                                        </Col>
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.coordinator_phone_number}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.enterprise_contact}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                            />
                                        </Col>
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.fax}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                            />
                                        </Col>
                                    </Row>
                                    
                                    <Row className="mt-3">
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.location}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                            />    
                                        </Col>
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.province_id}
                                                option={{source: 'db', data: Masterbase?.province}}
                                                hr={false}
                                                callback={(e, element) => {
                                                    onInputChange(e, element);
                                                    onInputChange({ target: { name: 'district_id', value: '' } }, element);
                                                    onInputChange({ target: { name: 'subdistrict_id', value: '' } }, element);
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.district_id}
                                                option={{
                                                    source: 'db', 
                                                    data: 
                                                        Inputs.province_id.value !== '' ? 
                                                        Masterbase?.district.filter( (d) => d.province_id === Inputs.province_id.value )
                                                    : []
                                                }}
                                                hr={false}
                                                callback={(e, element) => {
                                                    onInputChange(e, element);
                                                    onInputChange({ target: { name: 'subdistrict_id', value: '' } }, element);
                                                }}
                                            />
                                        </Col>  
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.subdistrict_id}
                                                option={{
                                                    source: 'db', 
                                                    data: 
                                                        Inputs.district_id.value !== '' ? 
                                                        Masterbase?.subdistrict.filter(
                                                            (s) => s.district_id === Inputs.district_id.value
                                                        )
                                                        : []
                                                }}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                            />
                                        </Col>
                                    </Row>
                                    {/* <Row className="mt-3">
                                        <Col md={12}><hr className="hr-custom" /></Col>
                                    </Row> */}
                                </>    
                            )||(
                                <>
                                    <Row>
                                        <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.fullname}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                        {/* <Col xs={12} sm={12} md={6} className="mt-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.position_id}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col> */}
                                    </Row>
                                </>
                            )}

                            <Row className="mt-3">
                                <Col xs={12} sm={12} md={6} className="mt-3">
                                    <CommonInput
                                        element="Inputs"
                                        input={Inputs.contact}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={6} className="mt-3">
                                    <CommonInput
                                        element="Inputs"
                                        input={Inputs.email}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col xs={12} sm={12} md={6} className="mt-3">
                                    <CommonFile
                                        element="Inputs"
                                        input={Inputs.profile_img}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 

                                        previewFile={(e) => onPreviewFile(e)} 
                                        deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                    />
                                </Col>
                            </Row>
                            
                            <Row className="mt-3">
                                <Col xs={12} sm={12} md={6} className="mt-3">
                                    <CommonInput
                                        element="Inputs"
                                        input={Inputs.username}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={6} className="mt-3"> 
                                    <CommonInput
                                        element="Inputs"
                                        input={Inputs.password}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </Col>
                            </Row>

                            <Row className='mt-5'>
                                <Col md={6} className="" style={{ alignSelf: 'end' }}>
                                    <ReCAPTCHA
                                            sitekey={SITE_KEY}
                                            onChange={this.handleRecaptchaChange}
                                            onExpired={this.handleRecaptchaExpired}
                                        />
                                    {this.state.recaptchaExpired && (
                                        <div className="text-danger mt-2">
                                            reCAPTCHA หมดอายุ กรุณาทำแบบทดสอบใหม่
                                        </div>
                                    )}
                                </Col>

                                <Col md={6} className="" style={{ alignSelf: 'end'}}>
                                   <div className="d-flex justify-content-end mt-2">
                                        <CommonButton 
                                            task={'new-register'} 
                                            disabled={
                                                isLoading || !this.state.recaptchaToken || Submit === false
                                            }
                                            callback={async (e) => {
                                                if (!this.state.recaptchaToken) {
                                                alert("กรุณายืนยัน reCAPTCHA ก่อนทำรายการ");
                                                return;
                                                }
                                                await onSubmit(e);
                                            }} 
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row className='mt-5'>
                                <CommonLoadingBar isLoading={isLoading} />
                                {console.log('Action.Alert',Action.Alert)}
                                <CommonAlert 
                                    alert={Action.Alert} 
                                    callback={(e) => onCloseAlert(e)}
                                />
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default InputRegister;